const $$splitErrorComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/github/callback.tsx?tsr-split=errorComponent');
const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/integrations/github/callback.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
const githubCallbackSchema = z.object({
  github_installation: z.enum(['success', 'error']).optional()
});
export const Route = createFileRoute('/(app)/integrations/github/callback')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  validateSearch: zodValidator(githubCallbackSchema),
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent')
});